if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let field_3322_16 = document.querySelector( ".field_3322_16" )
    let hidden_added = false;
    if( field_3322_16 ){

        field_3322_16 = [...field_3322_16.querySelectorAll( "input[name*='what_catches_your_eye'], input[name*='what_type_of_trip_are_you_planning_']" )]
        
        field_3322_16.forEach( ( item, index ) => {

            item.addEventListener( "click", (e) => {
                if( e.target.checked && !hidden_added ){

                    let form = document.querySelector( "#form_id-3322" )
    
                    let hidden = document.createElement( "input" )
                    hidden.type = "hidden"
                    hidden.name = "_access_token"
                    hidden.value = "a9604454-a9bf-41f9-95da-1e1ce4078e20"
    
                    form.appendChild( hidden )
                    hidden_added = true;
                    
                }
            } )

        } )

    }

    let form_id_3873 = document.querySelector( "input[name='form_id'][value='3873']" );
    if( form_id_3873 ){
        form_id_3873 = form_id_3873.parentElement;

        let golden = document.createElement( "input" )
        golden.type = "hidden"
        golden.name = "STAYGOLDEN"
        golden.value = "Enrolled"
        form_id_3873.appendChild( golden )
    }

    let form_id_3664 = document.querySelector( "#form_id-3818" )
    if( form_id_3664 ){

        let tokens = document.createElement( "input" )
        tokens.type = "hidden"
        tokens.name = "_access_token"
        form_id_3664.appendChild( tokens )

        let golden = document.createElement( "input" )
        golden.type = "hidden"
        golden.name = "STAYGOLDEN"
        golden.value = "Enrolled"
        form_id_3664.appendChild( golden )

        let checks = document.querySelectorAll( ".field_3818_21 input, .field_3818_25 input" )
        
        checks.forEach( ( item, index ) => {

            item.addEventListener( "click", ( e ) => {

                let token_of_list = "";

                let value_checkbox = e.target.parentNode.querySelector( "input" ).value

                switch (value_checkbox) {

                    case 'stay_golden_rewards':
                        token_of_list = '9bc59b93-38dd-4356-b744-c620a2772b36, 39d5fca2-62ac-4f08-97f3-73b181deab1c';
                        break;
                    case 'special_events_&_happenings':
                        token_of_list = 'c60f2ec9-233f-4c44-937d-1220077e4a0e';
                        break;
                    case 'dining_&_culinary':
                        token_of_list = 'd2192d78-0805-476c-a494-00079e96546f';
                        break;
                    case 'the_spa_&_wellness':
                        token_of_list = 'c60f2ec9-233f-4c44-937d-1220077e4a0e';
                        break;
                    case 'wedding_planning':
                        token_of_list = 'ad8f3b48-c14e-4982-9b11-5f3d57ebc768';
                        break;
                    case 'dining_&_culinary':
                        token_of_list = '5cb5b192-b02b-4f14-b032-8c5fe38a331d';
                        break;
                    case 'meetings_&_conferences':
                        token_of_list = 'f46fb21b-bf9d-4dbe-9599-383bdda38b22'
                        break;
                    case 'outdoors_&_adventure':
                        token_of_list = 'bca2d132-1f8f-4e4c-b47f-fe3ad3398e0a'
                        break;
                    case 'anniversary':
                        token_of_list = '479ff613-5762-49b9-ba78-21827d8af595'
                        break;
                    case 'honeymoon':
                        token_of_list = '8386cf4e-3c39-427a-b1d5-f7b8f4674cf2'
                        break;
                    case 'babymoon':
                        token_of_list = '35634c7c-5cf1-4bd0-a195-a684f1b3dd6b'
                        break;
                    case 'other_milestone':
                        token_of_list = 'a8d04b8c-8db8-4093-bd97-776873406e33'
                        break;
                    case 'general_vacation':
                        token_of_list = 'dd0f207c-8a2c-46f9-8ebe-d29438b6efe4'
                        break;
                }

                let values = tokens.value

                if( values.indexOf( token_of_list ) != "-1" ){
                    values = values.replace( token_of_list + ",", "" )
                    tokens.value = values
                }else{
                    values += token_of_list + ","
                    tokens.value = values
                }

            } )

        } )

        let first_time_token = "ce759e5f-2125-4b44-a77b-d47de68b4894,"
        let is_tis_your_first_time_visiting_kauai_ = document.querySelector( "input[name*=is_tis_your_first_time_visiting_kauai_]" )
        if (is_tis_your_first_time_visiting_kauai_){
            is_tis_your_first_time_visiting_kauai_.addEventListener( "click", () => {
                
                console.log( is_tis_your_first_time_visiting_kauai_.value );

                if( is_tis_your_first_time_visiting_kauai_.value == "yes" ){
                    if( tokens.value.indexOf( first_time_token ) == "-1" )
                        tokens.value += first_time_token
                }else{
                    tokens.value = tokens.value.replace( first_time_token, "" )
                }
            } )            
        };
        

    }

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.sym-slides').slick({
        accessibility: true        
    });

    $('.awards-mobile-slide').slick({
        accessibility: false,
        arrows:false,
        dots: true
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: true
    });

    //$('.images-slides figure').attr('aria-hidden', false);

    $('.slider-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.slider-bg-content').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.gallery-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        slidesToShow: 4,
        slidesToScroll: 1,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.selection-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true
    });

    $('.awards-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: true,
        responsive: [
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }
    $('#search').on('keyup',function(){
        const   searchText = $(this).val().toLowerCase(),
            items       = document.getElementsByClassName('accordion-item');

        if(searchText.length>2){
            for (let index = 0; index < items.length; index++) {
                items[index].classList.remove('hidden')
                //const title = items[index].parentElement.getElementsByClassName('title-item')[0].innerText.toLowerCase();
                if(items[index].innerText.toLowerCase().indexOf(searchText)==-1){
                    items[index].classList.add('hidden')
                }
            }
        }else{
            for (let index = 0; index < items.length; index++) {
                items[index].classList.remove('hidden');
            }
        }
        setTimeout(()=>{
            $('.accordion-block').each(function(i,element){
                if($('.accordion-item:not(.hidden)',element).length==0){
                    $(element).addClass('hidden')
                }else{
                    $(element).removeClass('hidden')
                }
            })
        },0)
    })

    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 44;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},400);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
        $('.learn-more-btn').append('<div class="arrow"></div>');
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 44;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 44;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book))").click(function(e){
        e.preventDefault();
        let strAncla = $(this).prop('hash').substr(1);
        animateto(strAncla);
    });

    let screenHeight = $(window).height();
    $('#home .top-img figure, #home .top-img video').css("height", screenHeight);

    $(window).resize(function(){
        screenHeight = $(window).height();
        $('#home .top-img figure, #home .top-img video').css("height", screenHeight);
    });

    $("input[name*=select_destination]").eq(0).attr("checked", "checked");

    // // ====== UPDATE thank You Message on sign-up form
	// const urlSignUpBTN = 'https://www.koakea.com/stay-golden';

	// function createAnchorButton( url ){
    //     let button = document.createElement('a');
    //     button.setAttribute('href', url);
    //     button.setAttribute('class', 'btn btn-primary');
    //     button.textContent = 'Join TODAY';

    //     console.log(button);

    //     return button;
	// }

	// if(document.querySelector('.sign-up ')){
    //     let formMessage = document.querySelector('.sign-up .thankyouMsg');

    //     let newMessage = "Thank you for signing up.</br> <span>You're Invited!</span> </br>Earn More Every Stay with Stay Golden Rewards at any Meritage Collection property. With this membership, you gain privileged access to exclusive pricing, rewards to enhance your stay, special offers and more. Make your stay count by signing up for our Stay Golden Rewards program and save more. </br>"


    //     formMessage.innerHTML = newMessage;
    //     formMessage.append( createAnchorButton( urlSignUpBTN ) );
	// }
	// // END =====  UPDATE thank You Message on sign-up form


    let form_signup_lightbox = document.querySelector('#form-sign-up');
    if( form_signup_lightbox ){
        let allGroup = form_signup_lightbox.querySelectorAll('.form-module__group');
        let prev_group = document.querySelector('.js-back_group');
        let next_group = document.querySelector('.js-next_group');
        let div_progress_bar = document.querySelector('.js-progressbar');
        let stateNumberBar = 1;
        let stateProgressBar = 100 / allGroup.length;

        form_signup_lightbox.querySelector('.gdpr-wrap').classList.add('hidden');
        form_signup_lightbox.querySelector('.form-module__submit').classList.add('hidden');
        allGroup.forEach( ( eachGroup, i ) => {
            if( i > 0 ){
                eachGroup.classList.add('hidden');
            }
        } );

        div_progress_bar.querySelector('label').textContent = `${stateNumberBar}/${allGroup.length}`;

        prev_group.addEventListener('click', (e) => {
            e.preventDefault();
            let currentGroupActive = form_signup_lightbox.querySelector('.form-module__group:not(.hidden)');
            let prevGroupActive = currentGroupActive.previousElementSibling;
            if( prevGroupActive.classList.contains('form-module__group') ){
                currentGroupActive.classList.add('hidden');
                prevGroupActive.classList.remove('hidden')
                stateNumberBar--;
                stateProgressBar = stateProgressBar - 100 / allGroup.length == 0 ? 25 : stateProgressBar - 100 / allGroup.length;
                div_progress_bar.querySelector('label').textContent = `${stateNumberBar}/${allGroup.length}`;
                div_progress_bar.querySelector('progress').value = `${stateProgressBar}`;
                if( stateNumberBar == 1 ){
                    prev_group.classList.add('hidden')
                }

                if( stateNumberBar < allGroup.length ){
                    form_signup_lightbox.querySelector('.gdpr-wrap').classList.add('hidden');
                    form_signup_lightbox.querySelector('.form-module__submit').classList.add('hidden');
                    next_group.classList.remove('hidden');
                }
            }
        });

        next_group.addEventListener('click', (e) => {
            e.preventDefault();
            let currentGroupActive = form_signup_lightbox.querySelector('.form-module__group:not(.hidden)');
            let nextGroupActive = currentGroupActive.nextElementSibling;
            let conunterError = 0;

            currentGroupActive.querySelectorAll('input.required, textarea.required, select.required, checkbox.required').forEach( input => {
                if( input.value == '' || !input.value || input.value == ' ' ){
                    conunterError++;
                }
            } )

            if( conunterError == 0 ){
                if( nextGroupActive.classList.contains('form-module__group') ){
                    currentGroupActive.classList.add('hidden');
                    nextGroupActive.classList.remove('hidden');
                    stateNumberBar++;
                    stateProgressBar = stateProgressBar + 100 / allGroup.length;
                    div_progress_bar.querySelector('label').textContent = `${stateNumberBar}/${allGroup.length}`;
                    div_progress_bar.querySelector('progress').value = `${stateProgressBar}`;
                    if ( prev_group.classList.contains('hidden') ) {
                        prev_group.classList.remove('hidden');
                    }
                    if( document.querySelector('.fill_fields') ){
                        document.querySelector('.fill_fields').classList.add('hidden')
                    }
                    if( !nextGroupActive.nextElementSibling.classList.contains('form-module__group') ){
                        form_signup_lightbox.querySelector('.gdpr-wrap').classList.remove('hidden');
                        form_signup_lightbox.querySelector('.form-module__submit').classList.remove('hidden');
                        form_signup_lightbox.querySelector('.advice_to_requiered_fiels').classList.add('hidden');
                        next_group.classList.add('hidden');
                        
                    }
                }
            }else{
                if ( !document.querySelector('.fill_fields') ) {
                    form_signup_lightbox.insertAdjacentHTML( "beforeend", "<strong class='fill_fields'>Please fill all the fields Required *</strong>" );
                }
            }
            
        })
    }

    
})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}